import { render, staticRenderFns } from "./summarypositiondata.vue?vue&type=template&id=6d8e5ac0&scoped=true&"
import script from "./summarypositiondata.vue?vue&type=script&lang=js&"
export * from "./summarypositiondata.vue?vue&type=script&lang=js&"
import style0 from "./summarypositiondata.vue?vue&type=style&index=0&id=6d8e5ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e5ac0",
  null
  
)

export default component.exports